import { render, staticRenderFns } from "./OrderKidsHistoryDetailDialog.vue?vue&type=template&id=0349f11a&scoped=true"
import script from "./OrderKidsHistoryDetailDialog.vue?vue&type=script&lang=js"
export * from "./OrderKidsHistoryDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderKidsHistoryDetailDialog.vue?vue&type=style&index=0&id=0349f11a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0349f11a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0349f11a')) {
      api.createRecord('0349f11a', component.options)
    } else {
      api.reload('0349f11a', component.options)
    }
    module.hot.accept("./OrderKidsHistoryDetailDialog.vue?vue&type=template&id=0349f11a&scoped=true", function () {
      api.rerender('0349f11a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/OderKids/OrderKidsHistoryDetailDialog.vue"
export default component.exports